export default "__VITE_ASSET__DICYA8kv__"